import type { User } from 'firebase/auth';

export function needsEmailVerification(user: User): boolean {
	return (
		!user.emailVerified && user.providerData.some((provider) => provider.providerId === 'password')
	);
}
